var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_vm._v(" 会員でない方は "),_c('a',{attrs:{"href":_vm.signUpUrl}},[_vm._v("サインアップ")]),_vm._v(" してください。 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }